// Link Preview Service
// Fetches Open Graph metadata from URLs to generate social media-style previews

import { supabase } from '../lib/supabase';

export const linkPreviewService = {
  /**
   * Fetch link preview metadata from a URL
   * @param {string} url - The URL to fetch metadata from
   * @returns {Promise<Object>} Preview metadata object
   */
  async fetchPreview(url) {
    try {
      // Validate URL
      const urlObj = new URL(url);
      
      // Call Supabase Edge Function to fetch preview
      const { data, error } = await supabase?.functions?.invoke('fetch-link-preview', {
        body: { url }
      });
      
      if (error) {
        throw new Error(error.message || 'Failed to fetch link preview');
      }
      
      if (!data) {
        throw new Error('No preview data returned');
      }
      
      return {
        url: data?.url,
        title: data?.title?.trim() || urlObj?.hostname,
        description: data?.description?.trim() || '',
        image: data?.image?.trim() || '',
        domain: data?.domain || urlObj?.hostname
      };
    } catch (error) {
      console.error('Link preview fetch error:', error);
      
      // Fallback: return basic info from URL
      try {
        const urlObj = new URL(url);
        return {
          url,
          title: urlObj?.hostname,
          description: url,
          image: '',
          domain: urlObj?.hostname
        };
      } catch {
        throw new Error('Invalid URL');
      }
    }
  },
  
  /**
   * Validate if a string is a valid URL
   * @param {string} string - The string to validate
   * @returns {boolean} True if valid URL
   */
  isValidUrl(string) {
    try {
      const url = new URL(string);
      return url?.protocol === 'http:' || url?.protocol === 'https:';
    } catch {
      return false;
    }
  }
};